import { render, staticRenderFns } from "./CreateDocumentValuation.vue?vue&type=template&id=a67a5138&scoped=true&"
import script from "./CreateDocumentValuation.vue?vue&type=script&lang=js&"
export * from "./CreateDocumentValuation.vue?vue&type=script&lang=js&"
import style0 from "./CreateDocumentValuation.vue?vue&type=style&index=0&id=a67a5138&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67a5138",
  null
  
)

export default component.exports